export const AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY =
  "efm-audit-dashboard-snapshot-v1";
export const AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY =
  "efm-audit-dashboard-restore-flag-v1";

/** List or details under reporting (same tab session snapshot is only for this subtree). */
export function isAuditReportingNavigationTarget(path: string | undefined): boolean {
  if (path == null || typeof path !== "string") {
    return false;
  }
  const base = path.split("?")[0].split("#")[0];
  return (
    base === "/audit-reporting" ||
    base.startsWith("/audit-reporting/")
  );
}

/** List route only — not details (`/audit-reporting/audit-details-page/...`). */
export function isAuditReportingListPath(path: string | undefined): boolean {
  if (path == null || typeof path !== "string") {
    return false;
  }
  const base = path.split("?")[0].split("#")[0].replace(/\/+$/, "");
  return base === "/audit-reporting";
}

export function clearAuditDashboardSessionStorage(): void {
  try {
    if (typeof sessionStorage === "undefined") {
      return;
    }
    sessionStorage.removeItem(AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY);
    sessionStorage.removeItem(AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

/** Call from routeExit: drop list snapshot when leaving the audit reporting area. */
export function clearAuditDashboardSessionStorageOnRouteExit(
  context: { path?: string } | undefined
): void {
  if (isAuditReportingNavigationTarget(context?.path)) {
    return;
  }
  clearAuditDashboardSessionStorage();
}
